import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminUsers = lazy(() => import("@/pages/admin/AdminUsers"));

export const Route = createFileRoute("/admin/users/")({
  component: AdminUsers,
});
